import React from 'react';
import { connect } from 'react-redux';
import {MasterLayout} from 'layout';
import classNames from 'classnames/bind';
import { Button, Collapse } from "@blueprintjs/core";
import { Link, browserHistory } from 'react-router';
import RowItemDocumentDetail from './RowItemDocumentDetail.jsx';
import DanhSachBangChung from './DanhSachBangChung.jsx';
import DataTable from 'components/data-table';
import {header} from "constants/table";
import moment from 'moment';
import {TextMessage} from 'components/tt-forms/common';
import {ShowIf} from 'components/utils';
import { TrangChu } from 'api';
import {
  ThongTinNguoiDungDon,
  ThongTinDonVuViec,
  ThongTinNguoiUyQuyen
} from 'modules/letter-information/letter-detail';

class ChiTietTraCuu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {},
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],
      loaiDonGiaTri: '',
      loaiDon: '',
      loaiDoiTuong: {},
      listTaiLieuBangChung: [],
      listTepChungChiHanhNghe: [],
      listTepUyQuyen: [],
      lichSuTrangThaiXLGQDons: '',
      isOpen: false,
      loading: false
    }
  }
  componentDidMount() {
    this.searchData(this.props.params.maDon);
    localStorage.setItem('tc.enableSearch', 1);
  }

  getlichSuTrangThaiXLGQDon(donId) {
    const {phamVi} = this.props.location.state;
    if (phamVi === 'SCOPE') {
      TrangChu.actions.getLichSuTrangThaiXLGQDonTaiDonVis.request(null, {donId: donId}).then(res => {
        if (res.data && res.data._embedded) {
          this.setState({ lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons });
        }
      });
    } else {
      TrangChu.actions.getlichSuTrangThaiXuLyGiaiQuyetDonToanHeThongs.request(null, {donId: donId}).then(res => {
        if (res.data && res.data._embedded) {
          this.setState({ lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons });
        }
      });
    }
    
  }

  searchData(key) {
    TrangChu.actions.getTraCuuDonCongDan.request(null, {maDon: key}).then(res => {
      if (res.data) {
        let donId = res.data.donId;
        let newState = {...this.state};
        newState.data = res.data;
        newState.data.loaiNguoiDungDon = res.data.loaiNguoiDungDonInfo.giaTri;
        newState.data.loaiVuViecInfo = {ten: res.data.loaiVuViec};
        newState.loaiNguoiDungDon = res.data.loaiNguoiDungDonInfo.giaTri;
        newState.dataNguoiDungDon = res.data.listNguoiDungDon;
        newState.dataDoanDiCung = res.data.listDoanDiCung;
        newState.loaiDon = res.data.loaiDonThuInfo.ten;
        newState.loaiDonGiaTri = res.data.loaiDonThuInfo.giaTri;
        newState.loaiDoiTuong = {ten: res.data.loaiDoiTuong};
        newState.linhVuc = res.data.linhVucDonThu;
        newState.linhVucChiTiet = res.data.linhVucDonThuChiTiet;
        newState.linhVucChiTietSub = res.data.linhVucChiTietKhac;
        newState.noiDung = res.data.noiDung;
        newState.dataNguoiDuocUyQuyen = res.data.nguoiDuocUyQuyen;
        this.setState({...newState});
        this.getlichSuTrangThaiXLGQDon(donId);
      }
    }).catch(error => {
    });
  }

  handleClick() {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name} type={this.props.route.type}>
        <div className="panel-page">
          <div className="center">
            <div className="back-foward">
              <Link onClick={browserHistory.goBack} title="" >Về trang trước</Link>
            </div>
            <div className="heading">
              <h2 className="heading-title icon-detail">Chi tiết đơn/vụ việc</h2>
            </div>
            <div className="main_page">
              {
                this.state.loaiDon ?
                  <div className="wrapper_box mb30">
                    <div className="page-wrapper mt0">
                      <div className="content-wrap content-gqd background-detail panel-page">
                        <div className="header-redirect background-detail">
                          <div className="box-items no-border">
                            <div className="row-col">
                              <TextMessage className="header-col pl15" label="Mã đơn:" value={this.state.data.maHoSo || ''} />
                              <TextMessage className="header-col" label="Ngày tiếp nhận:" value={this.state.data.ngayTao ? moment(this.state.data.ngayTao).format('DD/MM/YYYY') : ''} />
                              <TextMessage className="header-col" label="Nguồn đơn:" value={this.state.data.nguonDon} />
                              <div className="header-col"></div>
                              <div className="pull-right pr15">
                                <Button onClick={this.handleClick.bind(this)} className={classNames('btn-collap', {'active': this.state.isOpen})} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wrap-block pl10 pr10 pt10">
                          <div className="wrap-blocks">
                            <Collapse isOpen={this.state.isOpen}>
                              <ThongTinNguoiDungDon
                                title="Thông tin người đứng đơn/Vụ việc"
                                parent={this.state}
                              />
                            </Collapse>
                            <ShowIf condition={this.state.data.coUyQuyen}>
                              <Collapse isOpen={this.state.isOpen}>
                                <ThongTinNguoiUyQuyen
                                  title="Thông tin người được ủy quyền"
                                  parent={this.state}
                                />
                              </Collapse>
                            </ShowIf>
                            <div className={classNames('box-items', {'no-margin': !this.state.isOpen})}>
                              <ThongTinDonVuViec
                                title="Thông tin đơn/Vụ việc"
                                isOpen={this.state.isOpen}
                                parent = {this.state}
                              />
                              {
                                this.state.data && this.state.data.listTaiLieuBangChung && this.state.data.listTaiLieuBangChung.length > 0 &&
                                  <DanhSachBangChung parent={this.state.data.listTaiLieuBangChung} />
                              }
                            </div>
                          </div>
                        </div>
                      </div>      
                    </div>
                    <ShowIf condition={this.state.lichSuTrangThaiXLGQDons && this.state.lichSuTrangThaiXLGQDons.length}>
                      <div className="page-wrapper">
                        <div className="box-items no-border">
                          <div className="box-forward">
                            <div className="title">
                              <div className="rows">
                                <div className="col-12">
                                  <h3>Quá trình xử lý</h3>
                                </div>
                              </div>
                            </div>
                            <div className="items-form">
                              <div className="rows">
                                <div className="col-12">
                                  <DataTable
                                    header={header.listTTXLGQD}
                                    dataList={this.state.lichSuTrangThaiXLGQDons}
                                    hidePagination={true}>
                                    <RowItemDocumentDetail/>
                                  </DataTable>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ShowIf>
                  </div>

                :
                  <div className="wrapper_box tc-box">
                    <div className="box-items">
                      <div className="container-box">
                        <div className="items-form">
                          <div className="rows">
                            Không tìm thấy đơn này.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

let bindStateToProps = state => {
  return {
  }
}

export default connect(bindStateToProps)(ChiTietTraCuu);



// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/ChiTietTraCuu.jsx